var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useCheckoutContext, } from "../../../../context/useCheckoutContext";
import { isEmpty } from "lodash";
import { useKushkiJsContext } from "../../../../context/useKushkiJsContext";
import { PaymentMethodsEnum } from "../../../../shared/constants/PaymentMethodEnum";
import { PaymentTypeEnum } from "../../../../shared/constants/PaymentTypeEnum";
import { CardTypeEnum } from "../../../../shared/constants/CardsEnum";
export var useKPayCvvState = function () {
    var checkoutContext = useCheckoutContext();
    var handlers = checkoutContext.handlers, amount = checkoutContext.amount, kpaySelectedPayment = checkoutContext.kpaySelectedPayment, paymentType = checkoutContext.paymentType, currency = checkoutContext.currency;
    var _a = useKushkiJsContext(), requestCardToken = _a.requestCardToken, requestBin = _a.requestBin, requestDeferred = _a.requestDeferred, requestBrandsLogos = _a.requestBrandsLogos, requestCardSubscriptionToken = _a.requestCardSubscriptionToken;
    var _b = useState(false), openTerms = _b[0], setOpenTerms = _b[1];
    var _c = useState(""), cardBrand = _c[0], setCardBrand = _c[1];
    var _d = useState(false), hasDeferred = _d[0], setHasDeferred = _d[1];
    var _e = useState([]), deferredInfo = _e[0], setDeferredInfo = _e[1];
    var _f = useState(false), isActive = _f[0], setIsActive = _f[1];
    var _g = useState(false), isDynamic = _g[0], setIsDynamic = _g[1];
    var _h = useState([]), months = _h[0], setMonths = _h[1];
    var _j = useState([]), monthsOfGrace = _j[0], setMonthsOfGrace = _j[1];
    var _k = useState([]), typesDeferred = _k[0], setTypeDeferred = _k[1];
    var _l = useState([]), brands = _l[0], setBrands = _l[1];
    var _m = useState(false), acceptTerms = _m[0], setAcceptTerms = _m[1];
    var _o = useState(true), showDeferredTypes = _o[0], setShowDeferredTypes = _o[1];
    var _p = useState({
        months: "",
        monthsOfGrace: "",
        typeDeferred: "",
    }), deferredCurrentValues = _p[0], setDeferredCurrentValues = _p[1];
    var form = useForm({
        shouldUnregister: false,
    });
    var handleOpenTerms = function (open) {
        setOpenTerms(open);
    };
    var reduceOptions = function (deferred, kind) {
        return deferred.reduce(function (acc, curr) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a["" + curr.type] = __spreadArrays(curr[kind]).map(function (m) { return ({
                label: m,
                value: m,
            }); }), _a)));
        }, {});
    };
    var getDeferred = function (newBin) { return __awaiter(void 0, void 0, void 0, function () {
        var cardType, typeDeferred;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, requestDeferred({
                        bin: newBin,
                    })];
                case 1:
                    cardType = _a.sent();
                    if (isEmpty(cardType)) {
                        setHasDeferred(false);
                    }
                    else {
                        setHasDeferred(true);
                        setDeferredInfo(cardType);
                        typeDeferred = cardType.map(function (opt) { return ({
                            label: opt.name,
                            value: opt.type,
                        }); });
                        setIsDynamic(true);
                        setTypeDeferred(typeDeferred);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getBin = function (newBin) { return __awaiter(void 0, void 0, void 0, function () {
        var cardBin;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, requestBin({ bin: newBin })];
                case 1:
                    cardBin = _a.sent();
                    setCardBrand(cardBin.brand);
                    return [2 /*return*/, cardBin];
            }
        });
    }); };
    var handleSetFields = function (kind, value) {
        var _a;
        if (kind === "activeQuote") {
            setIsActive(!isActive);
        }
        else if (kind === "months" ||
            kind === "monthsOfGrace" ||
            kind === "typeDeferred") {
            if (kind === "typeDeferred") {
                setHasDeferred(true);
                var month = reduceOptions(deferredInfo, "months");
                var monthOfGrace = reduceOptions(deferredInfo, "monthsOfGrace");
                setMonths(month[value]);
                setMonthsOfGrace(monthOfGrace[value]);
                if (!month[value])
                    return;
                setDeferredCurrentValues({
                    months: month[value][0].value,
                    monthsOfGrace: !isEmpty(monthOfGrace[value])
                        ? monthOfGrace[value][0].value
                        : "",
                    typeDeferred: value,
                });
                return;
            }
            setDeferredCurrentValues(__assign(__assign({}, deferredCurrentValues), (_a = {}, _a[kind] = value, _a)));
        }
    };
    var tokenKpayRequest = function (walletId, cvv) {
        return requestCardToken({
            amount: amount.total,
            currency: amount.currency,
            cvv: cvv,
            isDeferred: deferredCurrentValues.months !== "",
            months: deferredCurrentValues.months !== "" ? +deferredCurrentValues.months : 0,
            walletId: walletId,
        });
    };
    var subscriptionTokenKpayRequest = function (walletId, cvc) {
        return requestCardSubscriptionToken({
            currency: currency,
            walletId: walletId,
            card: {
                cvc: cvc,
            },
        });
    };
    var handleSubmit = function (formData) { return __awaiter(void 0, void 0, void 0, function () {
        var card, tokenResponse, _a, checkoutToken, e_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!kpaySelectedPayment || !formData.terms)
                        return [2 /*return*/, null];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, , 7]);
                    card = __assign({}, kpaySelectedPayment);
                    handlers.setTokenRequestLoading(true);
                    if (!(paymentType === PaymentTypeEnum.UNIQUE)) return [3 /*break*/, 3];
                    return [4 /*yield*/, tokenKpayRequest(card.id, formData.cvc)];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, subscriptionTokenKpayRequest(card.id, formData.cvc)];
                case 4:
                    _a = _b.sent();
                    _b.label = 5;
                case 5:
                    tokenResponse = _a;
                    checkoutToken = {
                        paymentMethod: paymentType === PaymentTypeEnum.UNIQUE
                            ? PaymentMethodsEnum.CARD
                            : PaymentMethodsEnum.SUBSCRIPTION,
                        secureId: tokenResponse.secureId,
                        secureService: tokenResponse.secureService,
                        token: tokenResponse.token,
                    };
                    if (deferredCurrentValues.months !== "") {
                        checkoutToken.deferredConfig = {
                            deferredType: deferredCurrentValues.typeDeferred,
                            graceMonths: deferredCurrentValues.monthsOfGrace,
                            months: +deferredCurrentValues.months,
                        };
                    }
                    handlers.setCheckoutToken(checkoutToken);
                    handlers.setTokenRequestLoading(false);
                    return [2 /*return*/, null];
                case 6:
                    e_1 = _b.sent();
                    console.error(e_1);
                    return [2 /*return*/, null];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var getBrands = function () { return __awaiter(void 0, void 0, void 0, function () {
        var cardTypeLogo, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    handlers.setCheckoutLoading(true);
                    return [4 /*yield*/, requestBrandsLogos()];
                case 1:
                    cardTypeLogo = _a.sent();
                    setBrands(cardTypeLogo);
                    return [3 /*break*/, 4];
                case 2:
                    e_2 = _a.sent();
                    console.error(e_2);
                    return [3 /*break*/, 4];
                case 3:
                    handlers.setCheckoutLoading(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var getData = function (bin) { return __awaiter(void 0, void 0, void 0, function () {
        var cardBin;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getBin(bin)];
                case 1:
                    cardBin = _a.sent();
                    if (cardBin.cardType !== CardTypeEnum.DEBIT)
                        getDeferred(bin);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        setAcceptTerms(false);
        getBrands();
    }, []);
    useEffect(function () {
        if (typesDeferred.length < 1)
            return;
        if (typesDeferred.length === 1 && !typesDeferred[0].label) {
            handleSetFields("typeDeferred", typesDeferred[0].value);
            setShowDeferredTypes(false);
        }
    }, [typesDeferred]);
    useEffect(function () {
        if (!kpaySelectedPayment)
            return;
        var maskedCardNumber = __assign({}, kpaySelectedPayment).maskedCardNumber;
        if (maskedCardNumber) {
            var bin = maskedCardNumber.substring(0, 6);
            getData(bin);
        }
    }, []);
    return {
        acceptTerms: acceptTerms,
        brands: brands,
        cardBrand: cardBrand,
        deferredCurrentValues: deferredCurrentValues,
        deferredOptions: {
            hasDeferred: hasDeferred,
            isActive: isActive,
            isDynamic: isDynamic,
            months: months,
            monthsOfGrace: monthsOfGrace,
            showDeferredTypes: showDeferredTypes,
            typesDeferred: typesDeferred,
        },
        form: form,
        handler: {
            handleOpenTerms: handleOpenTerms,
            handleSetFields: handleSetFields,
            handleSubmit: handleSubmit,
        },
        openTerms: openTerms,
    };
};
